import { Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';

export default function FormTitle({ title }) {
    return (
        <Grid size={12}>
            <Typography variant="h4" gutterBottom style={{ fontSize: '1.5rem', padding: '0.5rem' }}>
                {title}
            </Typography>
        </Grid>
    );
}